import cx from 'classnames';

import EditorBlockBar from 'components/shared/EditorBlockBar';

import { useSmMenu } from './functions';
import styles from './index.module.css';
import { ISmMenuProps } from './types';

function SmMenu({
  lowerPosition,
  hasFastFactsButton,
  hasImageButton,
  hiddenTrash,
  className,
  hasDocumentButton,
}: ISmMenuProps) {
  const { items } = useSmMenu(hasDocumentButton, hasImageButton, hiddenTrash);

  if (!items.length) return null;

  return (
    <div className={cx(styles.wrapper, className)}>
      {/*@ts-ignore*/}
      <EditorBlockBar
        className={hasFastFactsButton && styles.trashIconPosition}
        items={items}
        lowerPosition={lowerPosition}
      />
    </div>
  );
}

export default SmMenu;
